'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const MicOffIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M16.25 11.75V7.25C16.25 4.90279 14.3472 3 12 3C10.6334 3 9.41741 3.64504 8.63994 4.64727M5.12407 14.75C6.2814 17.3989 8.92453 19.25 12 19.25C13.7832 19.25 15.4211 18.6277 16.7083 17.5883M12 21.5V19.5M7.75 8.75V11.75C7.75 14.0972 9.65279 16 12 16C12.8956 16 13.7264 15.723 14.4116 15.25M3 3.25L7.75 8L21 21.25L3 3.25Z",
        stroke: "currentColor",
        strokeLinecap: "square"
      }
    )
  }
);
const VpMicOffIcon = forwardRef(MicOffIcon);

export { VpMicOffIcon as default };
